import { useState } from "react";
import { getIn } from "formik";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker as DatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { InputLabel, TextField, Typography, Box } from "@mui/material";
import moment from "moment";

export const DateFormField = ({
	field,
	form,
	label,
	minDate,
	requiredCancel,
	disabled,
	maxDate,
	onValueChange,
	isRequired,
	...props
}) => {
	
	const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);
	const [inputValue, setInputValue] = useState(field.value ? moment(field.value).format("YYYY-MM-DD") : null);
    
	return (
		<Box>
			<LocalizationProvider dateAdapter={AdapterMoment}>
				{label && (
					<InputLabel shrink htmlFor={field.name}>
						<Typography variant="h6" lineHeight={""} sx={{ textTransform: "capitalize" }}>
							{label}
							{isRequired && (
								<Typography variant="h6" color="error" component="span">
									{" *"}
								</Typography>
							)}
						</Typography>
					</InputLabel>
				)}
				<DatePicker
					onChange={(value) => {
						// Ensure value is a valid Moment object before setting state
						const momentValue = moment(value);

						if (momentValue.isValid()) {
							form.setFieldValue(field.name, momentValue.format("YYYY-MM-DD"), true);
							onValueChange?.(momentValue.format("YYYY-MM-DD"));
							setInputValue(momentValue.format("MM/DD/YYYY"));
						} else {
							form.setFieldValue(field.name, null, true);
							setInputValue(null);
						}
					}}
					minDate={minDate ? moment(minDate) : null}
					maxDate={maxDate ? moment(maxDate) : null}
					value={field.value ? moment(field.value) : null}

					sx={{
						backgroundColor: "#F7FAFF",
						border: "1px solid #4169E1",
						borderRadius: "5px",
						width: "100%",
						
						"& fieldset": { border: "none" },
						"& .MuiInputBase-input": { padding: "12px 10px" },
						"& .css-1dune0f-MuiInputBase-input-MuiOutlinedInput-input": { fontSize: "12px" }
					}}
					renderInput={(params) => (
						<TextField
							{...params}
							id={field.name}
							// error={Boolean(errorText)}
							// helperText={errorText}
							fullWidth
							{...field}
							{...props}
							label={undefined}
							sx={{
								"label + &": {
									marginTop: -0.7,
								},
								mb: 1.5,
							}}
							disabled={disabled}
						/>
					)}
					inputFormat="MM/DD/YYYY"
					componentsProps={
						requiredCancel ? {} : { actionBar: { actions: ["today", "cancel"] } }
					}
					disabled={disabled}
				/>
				{errorText && <Typography variant="h6" fontSize={"10px"} color="red">{errorText}</Typography>}
			</LocalizationProvider>
		</Box>
	);
};